import './index.scss';
import { LoadingElement } from 'ii-react-sdk/layout_components';
import React from 'react';
import { useComparison } from '../provider';
import DocumentsPanel from './documents_panel';
import LeftPanel from './left_panel';
import { DocumentsViewProvider } from './provider';
const DocumentsView = () => {
    const { isInitializing } = useComparison();
    if (isInitializing) {
        return React.createElement("div", { className: 'main-content page-content-wrapper', "data-public": true },
            React.createElement("div", { className: 'document-comparison-container documents' },
                React.createElement(LoadingElement, { large: true, isLightBackground: true, text: 'Loading Documents for Comparison...', heading: true })));
    }
    return React.createElement("div", { className: 'document-comparison-container documents' },
        React.createElement(LeftPanel, null),
        React.createElement(DocumentsPanel, null));
};
const DocumentsViewWrapper = () => React.createElement(DocumentsViewProvider, null,
    React.createElement(DocumentsView, null));
export default DocumentsViewWrapper;
